import { render, staticRenderFns } from "./LoginMessage.vue?vue&type=template&id=1c1887f4&scoped=true&"
import script from "./LoginMessage.vue?vue&type=script&lang=js&"
export * from "./LoginMessage.vue?vue&type=script&lang=js&"
import style0 from "./LoginMessage.vue?vue&type=style&index=0&id=1c1887f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1887f4",
  null
  
)

export default component.exports